import { gql, useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { FeedbackModal } from './FeedbackModal';

export const submitPostDeletionFeedbackMutation = gql`
  mutation UI__SubmitPostDeletionFeedbackMutation(
    $feedback: String!
    $targetType: DeletionTargetType!
    $targetIdentifier: ID!
  ) {
    submitPostDeletionFeedback(
      feedback: $feedback
      targetType: $targetType
      targetIdentifier: $targetIdentifier
    )
  }
`;

interface Props {
  isOpen: boolean;
  onComplete: () => void;
  targetIdentifier: string;
  targetType: GraphQLTypes.DeletionTargetType;
}

export function PostDeleteFeedbackModal({
  targetIdentifier,
  targetType,
  isOpen,
  onComplete,
}: Props) {
  const [submitPostDeletionFeedback, { loading }] = useMutation<
    GraphQLTypes.UI__SubmitPostDeletionFeedbackMutation,
    GraphQLTypes.UI__SubmitPostDeletionFeedbackMutationVariables
  >(submitPostDeletionFeedbackMutation);

  return (
    <FeedbackModal
      isOpen={isOpen}
      title={
        targetType === GraphQLTypes.DeletionTargetType.USER
          ? 'Sorry to see you go. We’d love to know why.'
          : 'Any feedback for us?'
      }
      onClose={onComplete}
      isSubmitting={loading}
      onSubmit={async (feedback) => {
        try {
          await submitPostDeletionFeedback({
            variables: {
              feedback,
              targetType,
              targetIdentifier,
            },
          });
        } catch (error) {
          // don't annoy the user if something failed here, but do log it to sentry
          Sentry.captureException(error);
        } finally {
          onComplete();
        }
      }}
      message={
        <>
          {' '}
          We’re always looking for ways to improve the product, so{' '}
          <em>why did you choose to delete your account</em>? Seriously, tell us
          the truth, we can take it.
        </>
      }
    />
  );
}
